enum PciDashboardProviderStatusEnum {
  Unknown = "Unknown",
  Terminated = "Terminated",
  Targeted = "Targeted",
  Excluded = "Excluded",
  Standard = "Standard",
  Untargeted = "Untargeted"
}

export { PciDashboardProviderStatusEnum };
